<template>
    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label"> 

        <label class="mdl-textfield__label">{{label}}</label> 
        
        <slot></slot>
            
    </div>
</template>

<script>
export default {
    name: 'XMdl', 
    props : {
        'label' : String, 
        'error' : String,
    },
    data(){
        return { }
    },

    mounted(){
        componentHandler.upgradeElement(this.$el)
        this.$el.classList.remove('is-invalid')
    },
    beforeDestroy(){
        componentHandler.downgradeElements(this.$el)
    },
    methods: {
        checkDirty(){
            this.$nextTick(()=>this.$el.MaterialTextfield.checkDirty())
        },
        update(){
            this.$nextTick(()=>{
                this.$el.MaterialTextfield.checkDisabled();
                // this.$el.MaterialTextfield.checkValidity();
                this.$el.MaterialTextfield.checkDirty();
                this.$el.MaterialTextfield.checkFocus();
            })
        }
    }

}
</script>
